var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "video-view",
        {
          attrs: {
            "video-id": "https://vimeo.com/625577468/47d3ed3bf5",
            variant: "is-green"
          }
        },
        [
          _c("template", { slot: "title-first" }, [
            _c("div", [
              _vm._v("\n        " + _vm._s(_vm.$t("header_10")) + "\n      ")
            ])
          ]),
          _c("template", { slot: "title-second" }, [
            _c("div", { staticClass: "underline" }, [
              _vm._v("\n        " + _vm._s(_vm.$t("header_11")) + "\n      ")
            ])
          ]),
          _c(
            "video",
            {
              attrs: { autoplay: "", muted: "", loop: "", playsinline: "" },
              domProps: { muted: true }
            },
            [
              _c("source", {
                attrs: {
                  type: "video/mp4",
                  src:
                    "https://media.blissapplications.com/videos/desktop-1440-clip-careers.mp4"
                }
              })
            ]
          )
        ],
        2
      ),
      _c("title-view", { attrs: { variant: "primary" } }, [
        _vm._v("\n    " + _vm._s(_vm.$t("careers_1")) + "\n  ")
      ]),
      _c(
        "div",
        { staticClass: "has-max-width" },
        [
          _c("title-view", { attrs: { variant: "subtitle" } }, [
            _c("span", [
              _vm._v("\n        " + _vm._s(_vm.$t("careers_2")) + "\n      ")
            ])
          ])
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "has-max-width" },
        [
          _c("title-view", { attrs: { variant: "subtitle" } }, [
            _c("span", [
              _vm._v("\n        " + _vm._s(_vm.$t("careers_3_1")) + "\n      ")
            ])
          ])
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "has-max-width" },
        [
          _c("title-view", { attrs: { variant: "subtitle" } }, [
            _c("span", [
              _vm._v("\n        " + _vm._s(_vm.$t("careers_3_2")) + "\n      ")
            ])
          ])
        ],
        1
      ),
      _c(
        "video-thumbnail-inline-view",
        { attrs: { "video-id": "706152061" } },
        [
          _c("template", { slot: "image" }, [
            _c("picture", [
              _c("source", {
                attrs: {
                  media: "--small",
                  "data-srcset":
                    "/static/images/careers2-mobile.png,\n          /static/images/careers2-mobile@2x.png 2x"
                }
              }),
              _c("source", {
                attrs: {
                  media: "--large",
                  "data-srcset": "/static/images/careers2.png"
                }
              }),
              _c("img", {
                staticClass: "lazyload",
                attrs: {
                  "data-sizes": "auto",
                  "data-src": "/static/images/careers2.png"
                }
              })
            ])
          ])
        ],
        2
      ),
      _c(
        "div",
        { staticClass: "has-max-width" },
        [
          _c("title-view", { attrs: { variant: "subtitle" } }, [
            _c("span", [
              _vm._v("\n        " + _vm._s(_vm.$t("careers_4")) + "\n      ")
            ])
          ])
        ],
        1
      ),
      _c("CareersView"),
      _c("footer-follow-view")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-43b3f324", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43b3f324","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/careers/index.vue
// module id = 575
// module chunks = 11